import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

/**
 * Classe qui définit le comportement des contrôles de formulaire concernant l'affichage des messages d'erreurs
 */
export class InstantErrorStateMatcher implements ErrorStateMatcher {
    /**
     * Retourne une valeur indiquant si le contrôle est en erreur.
     * @param control Instance du contrôle.
     * @param form  Instance du formulaire.
     * @returns Une valeur indiquant si le contrôle est en erreur.
     */
    isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
        return control && control.invalid && (control.dirty || control.touched);
    }
}
